import { Card, CardContent, CardHeader } from '@flexibilitypay/ui';

/**
 * (Backfill automático — agregar descripción)
 *
 * @taskId T058
 * @see functional/Specs/specs_cycle-2.md HU-27-BE
 * @see functional/Specs/specs_cycle-2.md HU-06-FE
 * @see functional/Specs/specs_cycle-2.md HU-13-FE
 */
export function BalanceSkeleton() {
  return (
    <Card data-testid="balance-skeleton">
      <CardHeader>
        <div className="h-4 w-40 rounded bg-muted animate-pulse" />
        <div className="mt-2 h-3 w-56 rounded bg-muted animate-pulse" />
      </CardHeader>
      <CardContent>
        <div className="h-10 w-48 rounded bg-muted animate-pulse" />
        <div className="mt-3 h-3 w-64 rounded bg-muted animate-pulse" />
      </CardContent>
    </Card>
  );
}
